import styled from 'styled-components';

export const ModalContent = styled.div`
  min-height: ${({ theme }) => theme.pxToRem(320)};
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

export const LoadingContainer = styled.div`
  width: 100%;
  display: flex;
  margin: ${({ theme }) => theme.spacing(20)} 0;
  justify-content: center;
`;

export const ButtonContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing(60)};
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: ${({ theme }) => theme.spacing(32)};

  .button {
    width: ${({ theme }) => theme.pxToRem(166)};
  }
`;

export const ThirdPartySearchContainer = styled.div`
  margin-top: 0;

  > *:first-child {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }
`;

export const SimpleTable = styled.table<{ dark?: boolean }>`
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: ${({ theme }) => theme.spacing(12)};
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-size: ${({ theme }) => theme.pxToRem(14)};
    line-height: 1.5;
    text-align: left;
    vertical-align: middle;
  }

  th {
    background-color: ${({ theme }) => theme.colours.crowberryBlue};
    color: ${({ theme }) => theme.colours.white};

    &:first-child {
      border-radius: ${({ theme }) => theme.pxToRem(5)} 0 0 0;
    }

    &:last-child {
      border-radius: 0 ${({ theme }) => theme.pxToRem(5)} 0 0;
    }
  }

  th:first-child,
  td:first-child {
    width: 310px;
  }

  th:nth-child(2),
  td:nth-child(2),
  th:nth-child(3),
  td:nth-child(3) {
    width: auto;
  }

  td,
  td > span {
    color: ${({ dark = false, theme }) => (dark ? theme.colours.white : theme.colours.black)};
  }

  tbody tr {
    border-left: 1px solid ${({ theme }) => theme.colours.concreteGray};
    border-right: 1px solid ${({ theme }) => theme.colours.concreteGray};
    border-bottom: 1px solid ${({ theme }) => theme.colours.concreteGray};
  }
`;

export const ResultsContainer = styled.div`
  .result-section-title {
    color: ${({ theme }) => theme.colours.black};
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-size: ${({ theme }) => theme.pxToRem(14)};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    letter-spacing: 0;
    line-height: 1.5;
    text-align: left;
  }

  .table-section-title {
    padding-top: ${({ theme }) => theme.spacing(24)};
    padding-bottom: ${({ theme }) => theme.spacing(8)};
    color: ${({ theme }) => theme.colours.black};
    font-family: ${({ theme }) => theme.typography.fontFamily.primary};
    font-size: ${({ theme }) => theme.pxToRem(14)};
    font-weight: ${({ theme }) => theme.typography.fontWeight.bold};
    letter-spacing: 0;
    line-height: 1.5;
    text-align: left;
  }
`;

export const LabelIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 310px;
`;

export const Label = styled.span`
  font-family: ${({ theme }) => theme.typography.fontFamily.primary};
  font-size: ${({ theme }) => theme.pxToRem(14)};
  color: ${({ theme }) => theme.colours.charcoalDust};
  height: 24px;
  line-height: 1.5;
  text-align: left;
  margin: 0;
  padding: 0;
`;

export const LinkageTableInput = styled.input`
  width: 100%;
  font-size: 14px;
  border: 0;
  border-radius: 4px;
  padding: 5px;
  outline: none;
`;

export const Separator = styled.div`
  width: 1;
  border: 1px solid ${({ theme }) => theme.colours.silverSand};
`;

export const HelperText = styled.p`
  padding-bottom: ${({ theme }) => theme.spacing(24)};
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme.colours.agedGray};
`;

export const CreateHelperText = styled.p`
  padding-top: ${({ theme }) => theme.spacing(40)};
  padding-bottom: ${({ theme }) => theme.spacing(24)};
  font-size: 15px;
  font-weight: 500;
  color: ${({ theme }) => theme.colours.agedGray};
`;
